import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../reusable/Select/Select';
import css from '../SelectCampaigns.module.css';

const PageSizeSelect = ({ options, value, onChange }) => {
  return (
    <Select
      options={options}
      value={value}
      defaultValue={value}
      placeHolder={value.value}
      className={`${css.selectPageSize}`}
      styleSingleValue={{ margin: '0 .8rem' }}
      stylePlaceholder={{ margin: '0 .8rem' }}
      styleInput={{ margin: '0 .8rem' }}
      styleMenu={{
        width: '90%',
        right: '320%',
        position: 'absolute',
        maxHeight: '100px',
        overflowY: 'auto',
      }}
      onChange={onChange}
    />
  );
};

PageSizeSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  value: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PageSizeSelect;
